import { getTimeWithTimeZone } from 'utility/general';
import { documentTypeLookUp } from 'utility/postApprovalLookUp';

const useProgressReportSubmissionData = (props) => {
    console.log(1111, props)
    const row = props.progressReportSubmission ?? [];

    const rawColumn = [
        {
            field: 'reportSeqNo',
            headerName: 'Sequence No.',
            width: 100,
        },
        {
            field: 'documentType', headerName: 'Document Type', width: 300,
            valueGetter: (params) => {
                return documentTypeLookUp[params.row.documentType]?.display ?? '-';
            },
        },
        {
            field: 'submissionDate', headerName: 'Submission Date', width: 150,
            valueGetter: (params) => {
                return params.row.submissionDate ? getTimeWithTimeZone(params.row.submissionDate).format('YYYY-MM-DD') : '-';
            },
        },
    ];

    return { columns: rawColumn, rawColumn: rawColumn, rows: row };
};

export default useProgressReportSubmissionData;
